import { Location } from '@reach/router'
import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'

import { actions as authActions, selectors } from '@cinch/oxd-redux/auth/src'

interface Props {
  isAuthenticated: boolean
  dealerIsAuthenticated: boolean
  login: () => any
  updateAuthState: () => any
}

const mapStateToProps = (state: any) => ({
  isAuthenticated: !!(state.oidc && state.oidc.user),
  dealerIsAuthenticated: selectors.isAuthedPartner(state),
})

const mapDispatchToProps = (dispatch: Dispatch) => ({
  login: () => dispatch(authActions.login()),
  updateAuthState: () => dispatch(authActions.updateAuth()),
})

const WrapWithDDAuthProtector: React.FC<Props> = ({
  isAuthenticated,
  dealerIsAuthenticated,
  login: logIn,
  children,
  updateAuthState,
}) => {
  useEffect(() => {
    window.addEventListener('storage', () => {
      updateAuthState()
    })

    return () => {
      window.removeEventListener('storage', () => {
        /* do nothing */
      })
    }
  }, [])

  return (
    <Location>
      {(location) => {
        const isAPartnersPage = location.location.pathname.startsWith('/partners')
        const isACallbackPage = location.location.pathname.startsWith('/auth-callback')

        if (isAuthenticated && !isACallbackPage && !isAPartnersPage && dealerIsAuthenticated) {
          logIn()
        }

        return children
      }}
    </Location>
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(WrapWithDDAuthProtector)
